import { autoinject } from 'aurelia-framework';
import { State } from '../../services/global-state';
import * as moment from 'moment';
import { PayrazrService } from '../../services/payrazr';
import { Payment } from './payment';
import { Router, CanActivateNextStep } from 'aurelia-router';

@autoinject
export class ScheduledPayments {
	nextPayment: any;
	scheduledPayments: any;
	isLoading = true;
	
	constructor(private state: State, private payrazrService: PayrazrService, private router: Router) {
		this.nextPayment = null;
		this.scheduledPayments = null;
	}

	attached() {
		this.refresh();
	}

	refresh() {
		this.isLoading = true;
		this.payrazrService.refreshGlobalCustomer()
			// this call in here in dashboard keeps the globalstate fresh in the Portal from user actions performed on children views by user
			// ... references of globalState from children views get the globalState from local storage.
			.then((state: State) => {
				this.state = state;
				this.loadSchedules();
			});
	}

	loadSchedules() {
		this.scheduledPayments = [];
		if (this.state.accounts) {
			this.state.accounts.forEach(account => {
				if (account.paymentPlans && account.paymentPlans.length > 0) {
					let portfolioSettings = this.state.business.fetchPortfolioSettings(account.portfolioName);
					account.paymentPlans.forEach(paymentPlan => {
						var currentPaymentPlan = this.scheduledPayments.find(sp => sp.plan.id === paymentPlan.id);
						if (paymentPlan.isCombinedCustomerAccount && currentPaymentPlan) {
							this.scheduledPayments.filter(sp => sp.plan.id === paymentPlan.id).forEach(element => {
								element.accountName = element.accountName + ',' + account.displayName;
							});
						} else {
							this.scheduledPayments = this.scheduledPayments.concat(paymentPlan.payments.map(payment => {
								return new Payment(paymentPlan, account.displayName, account.id, paymentPlan.paymentInstrument, payment, portfolioSettings, account.contactName);
							}));
						}
					});
				}
			});
		}
		
		this.scheduledPayments = this.scheduledPayments
			.sort((a: Payment, b: Payment) => {
				const aDate = moment(a.paymentDate);
				const bDate = moment(b.paymentDate);

				if (aDate.isAfter(bDate)) {
					return 1;
				} else if (aDate.isSame(bDate)) {
					return 0;
				} else {
					return -1;
				}

			})
			.slice(0, 6);

		if (this.scheduledPayments.length > 0) {
			this.nextPayment = this.scheduledPayments[0].paymentDate;
		}
		this.isLoading = false;
	}

	cancel(payment: Payment) {
		const cancelRoute = this.router.routes.find(x => x.name === 'scheduled-payments/cancel-single-future');
		cancelRoute.payment = payment;
		this.router.navigateToRoute(cancelRoute.name);
	}

	view(payment: Payment) {
		let planRoute = 'installments/view-installments';
		if (payment.plan.isRecurring) {
			planRoute = 'recurring/view-recurring';
		}

		this.router.navigateToRoute(planRoute, { id: payment.accountId });
	}
}

